import React from 'react'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'

import { useUnsafeCallback } from './useCallback'

export type MouseCoordType = {
  x: number
  y: number
}

const useMouseCoords = () => {
  const [cursor, setCursor] = React.useState({ x: 0, y: 0 })

  const handleMouseFunction = useUnsafeCallback(
    (e: MouseEvent) => {
      const x = e.clientX
      const y = e.clientY

      setCursor({ x, y })
    },
    [setCursor]
  )

  // I don't want to load the function every render due to the fact that I will create N functions to track the mouse coordinates,
  // that's why I only read the mouse event ONE time
  useUnsafeEffect(() => {
    document.body.addEventListener('mousemove', handleMouseFunction)

    return () => {
      document.body.removeEventListener('mousemove', handleMouseFunction)
    }
  }, [handleMouseFunction])

  return cursor
}

export default useMouseCoords
